import { tsrContractsClient } from '../tsrContractsClient';

export const patientConcessionCardClient = () => tsrContractsClient.patientConcessionCardContract;
